(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name main.entitats.controller:entitatsCtrl
   *
   * @description
   *
   */
  angular
    .module('itecAdministracio.productes.main.submain.entitats')
    .controller('ProductesMainEntitatsCtrl', ProductesMainEntitatsCtrl);

  function ProductesMainEntitatsCtrl(ProducteFactory,$window, $rootScope,$stateParams,$state,$scope,Notification,HelperFactory) {
    var vm = this;
    vm.ctrlName = 'ProductesMainEntitatsCtrl';
    vm.llista=[];

      
    vm.cercaObj = {
      page : vm.page,
      perPage: vm.perPage,
      pages: vm.pages,
      nom: '',
      codiclient: '',
      nif:''
    };

    vm.load = load;
    vm.page = 1;
    vm.perPage = 25;
    vm.pages = 0;
    vm.canLoad = true;
    vm.view=view;
    
     vm.formulari = {
      nom: 'cercador',
      func: function(){
        cercar();
      },
      camps: [
          {
            type: 'text',
            name: 'nom',
            label: 'DEFAULT_NOM',
            columns: 4,
            required: false
          },
          {
            type: 'text',
            name: 'codiclient',
            label: 'DEFAULT_CODI_client',
            columns: 4,
            required: false,
            show:$rootScope.issuperadmin
           },
           {
             type: 'text',
             name: 'nif',
             label: 'DEFAULT_NIF',
             columns: 4,
             required: false,
             show:$rootScope.issuperadmin
            }
      ]
    }
    
    function loadEntitats() {
        var promise = ProducteFactory.getProducteEntitats($stateParams.idProducte, vm.cercaObj).then(function(response){
          $scope.$evalAsync(function(){
            vm.cercaObj.pages = response.data.pages;
            vm.cercaObj.page = response.data.page + 1;
            angular.forEach(response.data.list, function(entrada) {
              vm.llista.push(entrada);
            });
          });
        }).catch(function(error){
          Notification.processError(error);
        });

        return promise;
      }

    
    function load(){
      if (!angular.isUndefined(vm.cercaObj.pages) && (vm.cercaObj.page < (vm.cercaObj.pages + 1)) ) {
        vm.canLoad = false;
        loadEntitats().then(function(){
          $scope.$evalAsync(function(){
            vm.canLoad = true;
          });
        });
      }
    }
    
    vm.fields = [
    {
      header: 'DEFAULT_NOM',
      type: 'text',
      name: 'nom'
    },
    {
      header: 'DEFAULT_CODI_client',
      type: 'text',
      name: 'codiclient'
    },
    {
      header: 'DEFAULT_NIF',
      type: 'text',
      name: 'nif'
    },
    {
      header: 'DEFAULT_CODI',
      type: 'text',
      name: 'codi'
    }
  ];

 
  function view(obj) {
      HelperFactory.setParams($stateParams, {'idEntitat': obj.id});

      if(!angular.isUndefined($rootScope.permisos.PRODUCTEENTMENU) && $rootScope.permisos.PRODUCTEENTMENU.read){
              var url = $state.href('entitats.main.submain.llicencies', $stateParams, {'reload': 'entitats.main.submain'});
      }
      else if (!angular.isUndefined($rootScope.permisos.ENTITATMENU) && $rootScope.permisos.ENTITATMENU.read){
              var url = $state.href('entitats.main.submain.dades', $stateParams, {'reload': 'entitats.main.submain'});
      }
      
      $window.open(url,'_blank');
  }

    function cercar(){
      vm.cercaObj.page = 1;
      vm.cercaObj.pages = undefined;
      vm.llista = [];
      loadEntitats();
    }

    cercar();  
    if (angular.isUndefined($stateParams.idEntitat)){
      $rootScope.$broadcast('entitats.main.showOptionSubmenu', {'show': false});
    }
 }
}());
